
const digest = 'f7044372d4dae1794cb80bcd0e6c3b7302ab361364ca13c2da4eb7dc7cbcda46';
const classes = {"wrapper":"_wrapper_1jpdn_1","title":"_title_1jpdn_11","email":"_email_1jpdn_15"};
const css = `._wrapper_1jpdn_1 {
  background-color: #ffffff;
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  color: #3C3F9C;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1jpdn_1 ._title_1jpdn_11 {
  font-size: 16px;
  font-weight: 700;
}
._wrapper_1jpdn_1 ._email_1jpdn_15 {
  font-weight: 700;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  